import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import moment from 'moment';
import { create_manual_link_path, get_deduplication as _get_deduplication, get_manual_link_path_example as _get_manual_link_path_example, get_topo_list, get_company_list as _get_company_list, update_deduplication as _update_deduplication, update_link as _update_link, get_link_list as _get_link_list, update_link_batch as _update_link_batch, get_manual_link_path_placeholder as _get_manual_link_path_placeholder, all_company_update, post_display_manual_path as _post_display_manual_path, check_manual_link_path as _check_manual_link_path, get_manual_path as _get_manual_path, create_manual_path_config as _create_manual_path_config, sort_manual_config_id as _sort_manual_config_id } from "../../services/Company/companyS";
import { get_system as _get_system } from "../../services/rate/rateS";
import { BossMessage } from "../../components/Common/BossMessages";
var initState = {
  dataSource: [],
  companyList: [],
  manualLinkPathExample: [],
  rules: [],
  //去重规则
  volume: 0,
  //去重内存
  toolTipContent: "The deduplication function will occupy 50MB of CPE memory in the center and 50MB at the edge respectively",
  memory: [],
  linkList: [],
  manual_link_path_placeholder: "",
  INIT: 0,
  OFFLINE: 0,
  ONLINE: 0,
  total: 0,
  pathselectionParse: '',
  manualPathList: []
};
var initState2 = {
  manualLinkPathExample: [],
  pathselectionParse: '',
  manual_link_path_placeholder: ""
};
export default {
  namespace: "mi0501Info",
  state: initState,
  effects: {
    init: function init(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(get_topo_list, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return put({
                type: "update",
                payload: {
                  dataSource: backData.result
                }
              });
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    get_link_list: function get_link_list(_ref3, _ref4) {
      var payload = _ref3.payload;
      var call = _ref4.call,
        put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(_get_link_list, payload);
            case 2:
              backData = _context2.sent;
              _context2.next = 5;
              return put({
                type: "update",
                payload: {
                  linkList: backData.result,
                  total: backData.total,
                  INIT: backData.init || 0,
                  ONLINE: backData.online || 0,
                  OFFLINE: backData.offline || 0
                }
              });
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    get_system: function get_system(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var backData, memData, key, time;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(_get_system, payload);
            case 2:
              backData = _context3.sent;
              memData = [];
              if (backData.msg === "ok" || backData.retcode === 0) {
                for (key in backData.data) {
                  time = moment.unix(backData.data[key].time).format("YYYY-MM-DD HH:mm:ss");
                  memData.push([time, backData.data[key].mem]);
                }
              }
              _context3.next = 7;
              return put({
                type: "update",
                payload: {
                  memory: memData
                }
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    getCompanyList: function getCompanyList(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context4.sent;
              _context4.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData.result
                }
              });
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    get_manual_link_path_example: function get_manual_link_path_example(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(_get_manual_link_path_example, payload);
            case 2:
              backData = _context5.sent;
              _context5.next = 5;
              return put({
                type: "update",
                payload: {
                  manualLinkPathExample: backData.success ? backData.result : ""
                }
              });
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    get_manual_link_path_placeholder: function get_manual_link_path_placeholder(_ref11, _ref12) {
      var payload = _ref11.payload,
        callback = _ref11.callback;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData, data;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_get_manual_link_path_placeholder, payload);
            case 2:
              backData = _context6.sent;
              data = backData.success ? backData.result : "";
              if (callback && typeof callback === 'function') {
                callback(data);
              }
              _context6.next = 7;
              return put({
                type: "update",
                payload: {
                  manual_link_path_placeholder: data
                }
              });
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    handleSubmit: function handleSubmit(_ref13, _ref14) {
      var payload = _ref13.payload,
        callback = _ref13.callback;
      var call = _ref14.call,
        put = _ref14.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var backData1, _backData;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              if (!(callback && typeof callback === 'function')) {
                _context7.next = 26;
                break;
              }
              if (payload.update.assign_type === "auto") {
                _context7.next = 15;
                break;
              }
              _context7.next = 4;
              return call(create_manual_link_path, payload.update);
            case 4:
              backData1 = _context7.sent;
              if (!backData1.success) {
                _context7.next = 12;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context7.next = 9;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 9:
              // const backData = yield call(update_link, {assign_type: payload.assign_type, id: payload.id,record:payload.record,link_id:payload.link_id});
              // if(payload.vm.props.location && payload.vm.props.location.search){
              //     payload.vm.props.history.push("/main/mi0501")
              // }
              callback('');
              _context7.next = 13;
              break;
            case 12:
              if (backData1.errors_msg && Array.isArray(backData1.errors_msg) && backData1.errors_msg.length > 0) {
                callback(backData1.errors_msg);
              } else {
                callback(backData1.result);
                BossMessage(false, "Editing failed:" + backData1.result);
              }
            // BossMessage(false, "@编辑失败:" + backData1.result)
            case 13:
              _context7.next = 26;
              break;
            case 15:
              _context7.next = 17;
              return call(create_manual_link_path, _objectSpread({}, payload.update, {
                content: ''
              }));
            case 17:
              _backData = _context7.sent;
              if (!_backData.success) {
                _context7.next = 25;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context7.next = 22;
              return call(all_company_update, {
                company_id: payload.init.company_id
              });
            case 22:
              // if(payload.vm.props.location && payload.vm.props.location.search){
              //     payload.vm.props.history.push("/main/mi0501")
              // }
              callback('');
              _context7.next = 26;
              break;
            case 25:
              if (_backData.errors_msg && Array.isArray(_backData.errors_msg) && _backData.errors_msg.length > 0) {
                callback(_backData.errors_msg);
              } else {
                callback(_backData.result);
                BossMessage(false, "Editing failed:" + _backData.result);
              }
            case 26:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    get_deduplication: function get_deduplication(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var backData, toolTipContent;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(_get_deduplication, payload);
            case 2:
              backData = _context8.sent;
              toolTipContent = "";
              if (!backData.success) {
                _context8.next = 18;
                break;
              }
              _context8.t0 = backData.result.rules.length;
              _context8.next = _context8.t0 === 0 ? 8 : _context8.t0 === 1 ? 10 : _context8.t0 === 2 ? 12 : 14;
              break;
            case 8:
              toolTipContent = "The deduplication function will occupy 50MB of CPE memory in the center and 50MB at the edge respectively";
              return _context8.abrupt("break", 16);
            case 10:
              toolTipContent = "The deduplication function will occupy 100M of CPE memory at the center and 100M at the edge respectively";
              return _context8.abrupt("break", 16);
            case 12:
              toolTipContent = "The deduplication function will occupy 200M of CPE memory in the center and 200M of CPE memory in the edge";
              return _context8.abrupt("break", 16);
            case 14:
              toolTipContent = "The deduplication function will occupy 50MB of CPE memory in the center and 50MB at the edge respectively";
              return _context8.abrupt("break", 16);
            case 16:
              _context8.next = 18;
              return put({
                type: "update",
                payload: {
                  rules: backData.result.rules,
                  volume: backData.result.volume,
                  toolTipContent: toolTipContent
                }
              });
            case 18:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    handelCheckboxChange: function handelCheckboxChange(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var toolTipContent;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              toolTipContent = "";
              _context9.t0 = payload.values.length;
              _context9.next = _context9.t0 === 0 ? 4 : _context9.t0 === 1 ? 6 : _context9.t0 === 2 ? 8 : 10;
              break;
            case 4:
              toolTipContent = "The deduplication function will occupy both the center and edge CPE memory" + parseInt((payload.memory / 2).toString(), 10) + "M";
              return _context9.abrupt("break", 12);
            case 6:
              toolTipContent = "The deduplication function will occupy both the center and edge CPE memory" + payload.memory + "M";
              return _context9.abrupt("break", 12);
            case 8:
              toolTipContent = "The deduplication function will occupy both the center and edge CPE memory" + 2 * payload.memory + "M";
              return _context9.abrupt("break", 12);
            case 10:
              toolTipContent = "The deduplication function will occupy 0M of CPE memory in the center and edge respectively";
              return _context9.abrupt("break", 12);
            case 12:
              _context9.next = 14;
              return put({
                type: "update",
                payload: {
                  rules: payload.values,
                  toolTipContent: toolTipContent
                }
              });
            case 14:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    update_deduplication: function update_deduplication(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var backData, pathname, len, name;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(_update_deduplication, payload.update);
            case 2:
              backData = _context10.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
                if (payload.vm.props.location && payload.vm.props.location.pathname) {
                  pathname = payload.vm.props.location.pathname;
                  len = pathname.split('/').length;
                  name = pathname.split('/')[len - 2];
                  if (name) {
                    payload.vm.props.history.push("/main/" + name);
                  } else {
                    payload.vm.props.history.push("/main/mi0501");
                  }
                } // payload.vm.props.history.push("/main/mi0501")
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    update_link: function update_link(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(_update_link, payload.update);
            case 2:
              backData = _context11.sent;
              if (!backData.success) {
                _context11.next = 11;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context11.next = 7;
              return call(all_company_update, {
                company_id: payload.initcompany.company_id
              });
            case 7:
              _context11.next = 9;
              return put({
                type: "get_link_list",
                payload: payload.init
              });
            case 9:
              _context11.next = 12;
              break;
            case 11:
              BossMessage(false, "Editing failed:" + backData.result);
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    update_link_batch: function update_link_batch(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_update_link_batch, payload.update);
            case 2:
              backData = _context12.sent;
              if (!backData.success) {
                _context12.next = 9;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context12.next = 7;
              return put({
                type: "get_link_list",
                payload: payload.init
              });
            case 7:
              _context12.next = 10;
              break;
            case 9:
              BossMessage(false, "Editing failed:" + backData.result);
            case 10:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    get_company_list: function get_company_list(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_get_company_list, payload);
            case 2:
              backData = _context13.sent;
              _context13.next = 5;
              return put({
                type: "update",
                payload: {
                  companyList: backData.result
                }
              });
            case 5:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    clearData: function clearData(_ref27, _ref28) {
      var payload = _ref27.payload;
      var select = _ref28.select,
        call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return put({
                type: "update",
                payload: _objectSpread({}, initState2)
              });
            case 2:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    post_display_manual_path: function post_display_manual_path(_ref29, _ref30) {
      var payload = _ref29.payload,
        callback = _ref29.callback;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!payload.tunnel_id) {
                _context15.next = 12;
                break;
              }
              _context15.next = 3;
              return call(_post_display_manual_path, payload);
            case 3:
              backData = _context15.sent;
              if (!backData.success) {
                _context15.next = 9;
                break;
              }
              _context15.next = 7;
              return put({
                type: "update",
                payload: {
                  pathselectionParse: backData.success ? backData.result : ""
                }
              });
            case 7:
              _context15.next = 10;
              break;
            case 9:
              if (callback && typeof callback === 'function') {
                if (backData.errors_msg && Array.isArray(backData.errors_msg) && backData.errors_msg.length > 0) {
                  callback(backData.errors_msg);
                } else {
                  BossMessage(false, "Editing failed:" + backData.result);
                }
              }
            // BossMessage(false,backData.result)
            case 10:
              _context15.next = 14;
              break;
            case 12:
              _context15.next = 14;
              return put({
                type: "update",
                payload: {
                  pathselectionParse: ""
                }
              });
            case 14:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    check_manual_link_path: function check_manual_link_path(_ref31, _ref32) {
      var payload = _ref31.payload,
        callback = _ref31.callback;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_check_manual_link_path, payload);
            case 2:
              backData = _context16.sent;
              if (callback && typeof callback === 'function') {
                callback(backData);
              }
            case 4:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    get_manual_path: function get_manual_path(_ref33, _ref34) {
      var payload = _ref33.payload,
        callback = _ref33.callback;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData, data, i;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_get_manual_path, payload);
            case 2:
              backData = _context17.sent;
              data = [];
              if (backData.data && backData.data.info) {
                for (i in backData.data.info) {
                  data.push(_objectSpread({}, backData.data.info[i]));
                }
              }
              if (callback && typeof callback === 'function') {
                callback(data);
              }
            // yield put({
            //     type:"update",
            //     payload:{
            //         manualPathList:data
            //     }
            // })
            case 6:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    create_manual_path_config: function create_manual_path_config(_ref35, _ref36) {
      var payload = _ref35.payload,
        callback = _ref35.callback;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_create_manual_path_config, payload.update);
            case 2:
              backData = _context18.sent;
              if (!(backData.retcode === 0)) {
                _context18.next = 10;
                break;
              }
              BossMessage(true, "Operation successful");
              _context18.next = 7;
              return put({
                type: "get_manual_path",
                payload: payload.init
              });
            case 7:
              if (callback && typeof callback === 'function') {
                callback();
              }
              _context18.next = 12;
              break;
            case 10:
              BossMessage(false, "Operation failed:" + backData.msg);
              if (callback && typeof callback === 'function') {
                callback({
                  noClose: true
                });
              }
            case 12:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    sort_manual_config_id: function sort_manual_config_id(_ref37, _ref38) {
      var payload = _ref37.payload,
        callback = _ref37.callback;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_sort_manual_config_id, payload);
            case 2:
              backData = _context19.sent;
              if (backData.retcode === 0) {
                callback(backData.retcode, backData.data.result);
              } else {
                if (backData.data.errors_msg && Array.isArray(backData.data.errors_msg) && backData.data.errors_msg.length > 0) {
                  callback(backData.retcode, backData.data.errors_msg);
                } else {
                  BossMessage(false, backData.msg);
                }
              }
            // if(callback && typeof callback === 'function'){
            //     callback({noClose:true})
            // }
            case 4:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};